export default __webpack_public_path__ + "static/media/12-24_Bs.8e2dac11.svg";